import { useContext } from "react";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";

import { Card } from "react-bootstrap";
import useCreateAction from "@beeldit/core/actions/create/useCreateAction";
import useRemoveAction from "@beeldit/core/actions/remove/useRemoveAction";
import { getTableConfig } from "@beeldit/core/helpers/tables";
import useListAction from "../actions/list/useListAction";
import useEditAction from "../actions/edit/useEditAction";

function CustomersAndPetsComponent(props: { modelConfig: any }) {
  const { modelConfig } = props;
  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
    setTableFilters,
  } = useListAction(modelConfig, user);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(modelConfig, indexFunction);

  const { getFunction, actionTemplate: editActionTemplate } = useEditAction(
    modelConfig,
    indexFunction,
    setTableFilters,
    prepareRemoveFunction
  );

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  let tableConfig = getTableConfig(modelConfig.tableConfig, {
    indexFunction: indexFunction,
    actionsFunctions: [],
    rowFunctions: [],
  });
  setTableConfig(tableConfig);

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <span>{t("customers_and_pets")}</span>
        <div>{listActionTemplate}</div>
      </Card.Header>

      <Card.Body>
        {editActionTemplate}
        {removeActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default CustomersAndPetsComponent;
